import styled, { css } from "styled-components";

import { Modal } from "@braze/beacon-core";

export const operatorModalStyles = css`
  .bcl-modal-backdrop,
  .bcl-modal-dialog {
    right: var(--operator-inline-width, 0px);
    width: calc(100vw - var(--operator-inline-width, 0px));
  }
`;

export const StyledBrazeModal = styled(Modal)`
  ${operatorModalStyles}
`;
